<!--
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-02-26 10:51:22
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-06-11 11:41:52
 * @FilePath: /designcenter/src/layout/components/Navbar.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div
    class="navbar"
    :class="{ 'manual-navbar': $route.name === 'OperationManual', 'navbar--region-open': regionSelectorOpen }"
  >
    <!-- <div class="navbar-left">
      <a :href="handleFsLink('/')">
        <img class="logo" src="https://resource.fs.com/mall/generalImg/20250515182750zmylkq.svg" alt="logo" />
      </a>
      <span class="line"></span>
      <img class="text" src="https://resource.fs.com/mall/generalImg/20250606151911jsqmvd.svg" alt="design center" />
    </div> -->
    <div class="navbar-right">
      <div class="navbar-user">
        <CustomSelect
          ref="selectProjectRef"
          v-if="$route.name !== 'OperationManual'"
          v-model="currentProjectId"
          :options="allProjectOptions"
          :is-shared="currentProjectIsShared"
          :placeholder="t('components/layout.navbarSelectProject')"
          :searchable="true"
          @change="handleChangeProject"
          @toggle="handleToggle"
        >
          <template #footer>
            <div class="select_footer_box">
              <div class="footer" @click.stop="addProject">
                <span class="iconfont iconfont_add icon-a-addproduct1"></span>
                <span class="text">{{ t('components/layout.navbarAddProject') }}</span>
              </div>
              <div class="footer" @click.stop="manageProjects">
                <span class="iconfont iconfont_manage icon-guanlixiangmu"></span>
                <span class="text">{{ t('components/layout.navbarManageProjects') }}</span>
              </div>
            </div>
          </template>
        </CustomSelect>
        <div class="flex">
          <RegionSelector @open-change="regionSelectorOpen = $event" />
          <HeaderAccount v-if="isLogin" />
          <HeaderAccountGuest v-else />
        </div>
      </div>
    </div>
  </div>

  <FeedBackPopup ref="feedBackPopupRef" />
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick, watch, computed } from 'vue'
import { useProjectStore } from '@/store/project'
import { useGraphStore } from '@/views/designCenter/store/graphStore'

import { useUserStore } from '@/store/user'
import { useHeaderStore } from '@/store/header'
import { userLoginLog } from '@/api/modules/user'
// import Icon from '@/components/Icon/Icon.vue'
import HeaderAccount from './HeaderAccount.vue'
import RegionSelector from './RegionSelector.vue'
import HeaderAccountGuest from './HeaderAccountGuest.vue'
import CustomSelect from './CustomSelect.vue'
import FeedBackPopup from '@/components/FeedBackPopup/FeedBackPopup.vue'
import { useRouter, useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { Cookie } from '@/utils'
import { useProductSelectionStore } from '@/store/productSelection'
import { trackEvent } from '@/utils/analytics'
import { useErrorState } from '@/composables/useErrorState'
import { recordCustomerOperation, CustomerOperationType } from '@/api/modules/common'
import { t } from '@/lang'

defineOptions({
  name: 'AppNavbar',
})

const { hideError } = useErrorState()

interface CustomSelectInstance {
  hideDropdown: () => void
}
interface ProjectOption {
  value: number
  templateId: number
  isCustomized: number
}
const graphStore = useGraphStore()
interface AddProjectPopupInstance {
  showDialog: () => void
}
const productSelectionStore = useProductSelectionStore()
const headerStore = useHeaderStore()
const projectStore = useProjectStore()
const userStore = useUserStore()
const { allProjectOptions, currentProjectId, currentProjectIsShared } = storeToRefs(projectStore)
const { show_feedback_popup } = storeToRefs(headerStore)

// 是否已登录：存在 token_new 则展示已登录账户组件，否则展示游客组件
const isLogin = computed(() => {
  return !!(Cookie.get('token_new') || localStorage.getItem('token_new'))
})
const router = useRouter()
const route = useRoute()
const regionSelectorOpen = ref(false)
const selectProjectRef = ref<CustomSelectInstance | null>(null)
const feedBackPopupRef = ref<AddProjectPopupInstance | null>(null)
// const selectedProject = ref<number | null>(localStorage.getItem('currentProjectId') ? parseInt(localStorage.getItem('currentProjectId') || '') : null)

const addProject = () => {
  selectProjectRef?.value?.hideDropdown()
  headerStore.showCreateProjectPopup()
  trackEvent({
    eventCategory: 'dec_topology',
    eventAction: 'project_add_click',
    eventLabel: 'add_project',
  })
}

const handleChangeProject = (item: ProjectOption) => {
  const previousProjectId = Number(localStorage.getItem('currentProjectId'))
  const isSameProject = Number.isFinite(previousProjectId) && previousProjectId === item.value

  graphStore.setShowDrawerPanel(false)
  graphStore.setShowPlaceDevices(false)
  hideError()
  productSelectionStore.clearSelectedProductIds()
  projectStore.setCurrentProjectIsShared(null)

  // 确保当前页面的项目监听器正常响应本次切换。
  projectStore.setProjectSwitching(false)

  // 如果选择的是当前已激活的项目，强制触发更新
  if (isSameProject) {
    projectStore.setCurrentProjectId(null)
    nextTick(() => {
      projectStore.setCurrentProjectId(item.value)
    })
  } else {
    projectStore.setCurrentProjectId(item.value)
  }
  if (item.templateId === 0 && item.isCustomized === 0) {
    headerStore.showSelectTemplatePopup()
  } else {
    projectStore.setCurrentTemplateId(item.templateId)
    // 使用 replace 替换当前历史记录，清除所有 URL 参数
    router.replace({ path: '/design-center', query: {} })
  }
}
const handleToggle = () => {
  graphStore.setShowDrawerPanel(false)
}
const manageProjects = () => {
  trackEvent({
    eventCategory: 'dec_topology',
    eventAction: 'project_manage_click',
    eventLabel: 'manage_projects',
  })
  selectProjectRef?.value?.hideDropdown()
  router.push({ path: '/project' })
}

// 监听反馈弹窗状态变化
watch(show_feedback_popup, newVal => {
  if (newVal) {
    feedBackPopupRef?.value?.showDialog()
    headerStore.hideFeedbackPopup() // 重置状态
  }
})

onMounted(async () => {
  // 公共页面（如操作手册）无需登录，跳过所有鉴权类接口请求，避免触发 401 重定向到登录页
  if (route.meta.public) {
    return
  }

  projectStore.getAllProjectList()
  await userStore.getCustomerType()
  await userStore.getUser()
  await userLoginLog({ userId: userStore.customersId })

  // 记录客户工具访问操作
  try {
    const currentProjectId = localStorage.getItem('currentProjectId')
    if (currentProjectId && userStore.customersId) {
      await recordCustomerOperation({
        projectId: 0,
        userId: userStore.customersId,
        typeId: CustomerOperationType.TOOL_ACCESS,
      })
    }
  } catch (error) {
    console.log('记录客户操作日志失败:', error)
  }
})
</script>

<style lang="scss" scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0 16px 0 0;
  background-color: #f4f5f6;
  flex-shrink: 0;
  // 保证 Navbar 内的下拉框高于内容区及局部 v-loading 遮罩（z-index: 1000），
  // 同时仍低于全屏 v-loading 遮罩（z-index: 2000）
  z-index: 1001;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #eee;
    z-index: 1;
  }

  &.manual-navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }

  &.navbar--region-open {
    z-index: 2000;
  }

  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // z-index: 1000;
  .navbar-left {
    display: flex;
    align-items: center;

    .line {
      width: 1px;
      height: 20px;
      background-color: #4c4948;
      margin: 0 8px;
    }

    .logo {
      display: inline-block;
      width: 76px;
    }

    .text {
      display: inline-block;
      width: 156px;
    }
  }

  .navbar-right {
    flex: 1;
    display: flex;
    align-items: center;

    .navbar-user {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;
      cursor: pointer;

      // 当存在 CustomSelect 时，使用 space-between 布局
      &:has(.custom_select) {
        justify-content: space-between;
      }

      > .flex {
        display: flex;
        align-items: center;
      }
    }
  }
}

.select_footer_box {
  padding: 11px 16px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eeeeee;

  .footer {
    height: 20px;
    width: 50%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    color: #19191a;
    @include font13;

    &:hover {
      .text {
        text-decoration: underline;
      }
    }
  }

  .iconfont {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 1;
    font-size: 16px;
    margin-right: 4px;
  }
}

.iconfont_nav {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 8px;
  font-size: 24px;
  border-radius: 4px;
  transform: all 0.3s;

  &:hover {
    background-color: #f2f2f2;
  }
}

// CustomSelect 样式覆盖 - 合并两次提交的改动
:deep(.custom_select) {
  // 移除固定宽度，添加 z-index
  width: auto !important;
  z-index: 10 !important;

  .select_box {
    // 移除灰色背景和边框，改为右边框设计
    border: none !important;
    border-right: 1px solid #dee0e3 !important;
    border-radius: 0 !important;
    background-color: transparent !important;

    // 调整内边距和高度
    padding: 10px 16px !important;
    height: 50px !important;

    // 添加间距和调整字体
    gap: 8px !important;
    @include font12;

    &:hover {
      background: #fff !important;

      // 移除伪元素效果
      &:after {
        display: none !important;
      }

      .iconfont_down {
        color: #19191a !important;
      }
    }

    &.select_box_active {
      border: none !important;
      border-right: 1px solid #dee0e3 !important;
      background: #fff !important;

      // 移除伪元素效果
      &:after {
        display: none !important;
      }

      .iconfont_down {
        color: #19191a !important;
        transform: rotate(-180deg) !important;
      }
    }

    .label_box {
      // 改为最小宽度而非固定宽度
      min-width: 120px !important;
      width: auto !important;
    }

    .iconfont_down {
      // 修复 CSS 属性错误
      transition: all 0.3s !important;
      transform: none !important;
    }
  }

  .dropdown {
    // 调整下拉框定位和尺寸
    left: 8px !important;
    width: 300px !important;
    margin-top: 8px !important;
  }

  .search_box {
    // 新增搜索框样式定制
    .fs-input {
      height: 30px !important;

      .fs-input__wrapper {
        padding: 5px 6px 5px 8px !important;

        .fs-input__box {
          .fs-input__search {
            padding: 3px !important;

            .iconfont {
              width: 14px !important;
              height: 14px !important;
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }

  .options_list {
    // 调整最大高度
    max-height: 252px !important;
  }

  .option_item {
    // 调整选项样式
    font-weight: 600 !important;
    color: #19191a !important;
    padding: 8px !important;
    margin-bottom: 0 !important;

    &:last-child {
      margin-bottom: 0 !important;
    }

    &.option_item_active {
      background: rgba(25, 25, 26, 0.06) !important;
      color: #19191a !important;
    }
  }
}
</style>
